<template>
  <div>
    <img src="@/assets/orderTest/user-selection/no-results.svg" alt="no results icon" class="mx-auto mb-2.5">
    <p class="text-base font-bold">No results Found</p>
    <p class="no-result-text">
      We couldn't find what you're looking for, click Add patient button to create new patient "{{ name }}".
    </p>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.no-result-text {
  width: 345px;
  color: #9B9B9B;
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0.34px;
  line-height: 14px;
  margin: 10px auto;
}
</style>